import { clsx } from 'clsx'
import { CSSProperties, MouseEvent, ReactNode } from 'react'
import { getGapStyle, getMarginStyle, getPaddingStyle, Margin, Padding, styles } from 'util/style'
import css from './Space.module.scss'

export type SpaceProps = {
  center?: boolean
  children?: ReactNode
  className?: string
  columns?: boolean
  fit?: boolean
  flex?: string
  gap?: number | [number, number]
  height?: number | string
  margin?: Margin
  maxHeight?: number | string
  maxWidth?: number | string
  minHeight?: number | string
  minWidth?: number | string
  oh?: boolean
  onClick?(event?: MouseEvent): unknown
  opposite?: boolean
  pad?: Padding
  right?: boolean
  panel?: boolean
  round?: boolean
  shrink?: boolean
  spread?: boolean
  stable?: boolean
  style?: CSSProperties
  tall?: boolean
  title?: string
  top?: boolean
  vertical?: boolean
  wide?: boolean
  width?: number | string
  wrap?: boolean
}

function buildStyle(props: SpaceProps) {
  const { flex, height, maxHeight, maxWidth, minHeight, minWidth, pad, style, width } = props
  const gap = getGapStyle(props.gap)
  const padding = getPaddingStyle(pad)
  const margin = getMarginStyle(props.margin)
  return styles({
    flex, width, height, minWidth, minHeight, maxWidth, maxHeight,
    ...gap, ...padding, ...margin, ...style,
  })
}

export function Space(props: SpaceProps) {
  const {
    center, children, columns, fit, oh, onClick, opposite, right, top,
    panel, round, shrink, spread, stable, tall, title, vertical, wide, wrap,
  } = props

  const style = buildStyle(props)
  const className = clsx(
    props.className,
    vertical ? css.column : css.row,
    !!onClick && css.action,
    top && css.top,
    center && css.center,
    right && css.right,
    oh && css.oh,
    opposite && css.opposite,
    panel && css.panel,
    round && css.round,
    shrink && css.shrink,
    spread && css.spread,
    stable && css.stable,
    columns && css.columns,
    fit && css.fit,
    wide && css.wide,
    tall && css.tall,
    wrap && css.wrap,
  )

  return <div className={className} style={style} title={title} onClick={onClick}>
    {children}
  </div>
}
